# CREATES A SETTING ON A 'PARENT' OBJECT IMMEDIATELY UPON SELECTING A GIVEN CHECKBOX.
#
# This is currently used on the settings page for enabling specific resources on
# the account, such as message templates that the account owner wishes to enable

$(->
  update_child_status = (child, status)->
    parent = child.closest('.child-status')
    $.ajax
      url: '/manage/' + parent.data('parent-type') + '/update_setting'
      type: 'PATCH'
      data: { child: { type: parent.data('child-type'), id: child.val(), status: status } }

  $('.child-status input.status').change ->
    the_wrapper = $(this).closest('.status-wrapper')
    if $(this).prop('checked')
      if the_wrapper.hasClass('single')
        group = $.grep the_wrapper.attr('class').split(' '), (e,i)->
          e.indexOf('group-') == 0
        $('.' + group + ' input.status').not($(this)).each ->
          $(this).prop('checked', false)
          $(this).closest('.status-wrapper').addClass('inactive')
          update_child_status($(this), 0)

      the_wrapper.removeClass('inactive')
      update_child_status($(this), 1)
    else
      the_wrapper.addClass('inactive')
      update_child_status($(this), 0)

)
